<template>
    <div class="blur-wrap w-full h-1000 lg:j-h-600 relative" :class="{ 'mb-300 lg:j-mb-0': isLogin }">
        <!-- 未登录 -->
        <div v-if="!isLogin" class="w-full h-full mx-auto relative">
            <BannerImage :isLogin="isLogin"/>
            <div class="w-full lg:j-w-1180 h-full mx-auto pt-55 lg:j-pt-120 lg:j-pl-80 relative">
                <h2 class="banner-title" v-html="t('member_index.banner.title')"></h2>
                <p class="w-full min-h-44 px-30 text-28 leading-44 lg:j-min-h-32 lg:max-w-[55%] lg:px-0 lg:j-text-18 lg:j-leading-26 font-medium  mt-20 lg:j-mt-20 text-center lg:text-left" :class="[currentStore?.cr === 'JP' ? 'text-[#ffffff]': 'text-[#E9E5E0]']" v-html="t('member_index.banner.description')"></p>
                <div class="flex items-center justify-center lg:justify-start gap-x-20 lg:j-gap-x-16 mt-16 lg:j-mt-30" :class="{ 'us-buttons': currentStore?.cr === 'US' }">
                    <button
                        class="button-base bg-primary text-white"
                        @click.prevent="acrossDomainJump(t('member_index.common.quick_login').toUpperCase())"
                    >{{ t('member_index.common.quick_login').toUpperCase() }}</button>

                    <button
                        v-if="currentStore?.cr === 'US'"
                        class="button-base bg-primary text-white"
                        @click.prevent="acrossDomainJump(t('member_index.common.register').toUpperCase())"
                    >{{ t('member_index.common.register').toUpperCase() }}</button>
                </div> 

            </div>
        </div>

        <!-- 已登录 -->
        <div v-else class="w-full h-full mx-auto relative">
            <BannerImage :isLogin="isLogin" />
            <div class="w-full lg:j-w-1180 h-full mx-auto pt-55 lg:j-pt-80 lg:j-pl-80 relative">
                <h2 class="banner-title" v-html="t('member_index.banner.title')"></h2>
                <p class="w-full min-h-44 px-30 text-28 leading-44 lg:j-min-h-64 lg:max-w-[55%] lg:px-0 lg:j-text-18 lg:j-leading-26 font-medium mt-16 lg:j-mt-20 text-center lg:text-left" :class="[currentStore?.cr === 'JP' ? 'text-[#ffffff]': 'text-[#E9E5E0]']" v-html="t('member_index.banner.description')"></p>
                <div class="amount-balance">
                    <div class="w-full h-full bg-white opacity-20 blur-[10px] absolute left-0 top-0 right-0 bottom-0 z-0"></div>
                    <div class="w-full h-full flex-center flex-col lg:flex-between lg:flex-row lg:j-pl-80 lg:j-pr-48 relative">
                        <div class="flex gap-20 lg:j-gap-x-100 text-[#6D6D6D]">
                            <span class="min-w-250 lg:min-w-auto flex-center flex-col">
                                <em class="amount-text">{{amountBalance.balancePoint}}</em>
                                <i class="amount-text-weak ">{{ t('member_index.banner.points_balance') }}</i>
                            </span>
                            <span class="min-w-250 lg:min-w-auto flex-center flex-col">
                                <em class="amount-text ">{{amountBalance.comingSoonPoint}}</em>
                                <i class="amount-text-weak ">{{ t('member_index.banner.coming_soon') }}</i>
                            </span>
                        </div>
                        <div class="flex flex-wrap mt-60 lg:j-mt-0 gap-30 lg:j-gap-38">
                            <button class="button-activity" @click="showRewardsModal">{{ t('member_index.banner.my_rewards') }}</button>
                            <button class="button-activity" @click="showActivityModal">{{ t('member_index.banner.my_activity') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- ReWards 弹窗 -->
    <RewardsModal ref="rewardsModal" :isLogin="props.isLogin" :points="amountBalance.balancePoint"/>

    <!-- Activity 弹窗 -->
    <ActivityModal ref="activityModal" :title="t('member_index.banner.my_activity')"/>
</template>

<script setup>
    import { pullBalanceAmount } from '@a/index';
    import RewardsModal from './banner/RewardsModal.vue';
    import ActivityModal from './banner/ActivityModal.vue';
    import BannerImage  from './banner/BannerImage.vue';
    import { gaPushDataLayer } from '@/utils/ga.js'
    import { useStore } from 'vuex';

    const router = useRouter();
    const { t } = useI18n();
    const store = useStore();

    const userInfo = computed(() => store.getters.userInfo);
    const currentStore = computed(() => store.getters.currentStore);

    const props = defineProps({
        isLogin: Boolean,
    })

    // 跨域名 跳转
    const acrossDomainJump = (text) => {
        const params = {
            module: "PasswordFreeLoginBanner",
            position: t('member_index.banner.title'),
            button_name: text
        }
        gaPushDataLayer(params)
        if(window.jackeryLoginApp) {
            window.jackeryLoginApp.modalLogin({
                return_url: `${window.location.origin}${window.location.pathname}`,
                register_act: 'MEM-Register'
            })
        }
        return
    }

    const amountBalance = reactive({
        balancePoint: 0,
        comingSoonPoint: 0,
    })

    const getAmountBalance = async () => {
        const { balancePoint, comingSoonPoint} = await pullBalanceAmount()
        amountBalance.balancePoint = balancePoint
        amountBalance.comingSoonPoint = comingSoonPoint
    }

   
    // Rewards 弹窗
    const rewardsModal = ref(null);
    const showRewardsModal = () => {
        const params = {
            jackery_id: userInfo.value.userName,
            button_name: t('member_index.banner.my_rewards')
        }
        gaPushDataLayer( params)
        rewardsModal.value?.openModal()
    }
    // Activity 弹窗
    const activityModal = ref(null)
    const showActivityModal = () => {
        const params = {
            jackery_id: userInfo.value.userName,
            button_name: t('member_index.banner.my_activity')
        }
        gaPushDataLayer( params)
        activityModal.value?.openModal()
    }

    // 判断当前是哪一个站点
    const isUSStore = computed(() => {
        return currentStore.value?.cr === 'US'
    })

    // 计算button的宽度
    onMounted(() => {
        if(props.isLogin) {
            getAmountBalance()

            // 监听抽奖活动完成，更新积分
            document.addEventListener('luckyDrawDone', (event) => {
                if (event.detail.status) {
                    getAmountBalance()
                }
            })
        } else {
            if (isUSStore.value) {
                const btns = document.querySelectorAll('.us-buttons .button-base')
                const maxWidth = Math.max(...Array.from(btns).map(btn => Math.ceil(btn.offsetWidth + 5)))
                btns.forEach(btn => (btn.style.width = maxWidth + 'px'))
            }
        }
    })

</script>
<style scoped>
    .banner-title {
        @apply
        w-full min-h-96 text-80 leading-96 font-medium text-[#fff] text-center lg:(j-min-h-75 j-text-56 j-leading-64 text-left)
    }
    .button-base {
    @apply
        h-80 lg:w-auto lg:j-px-24 lg:j-h-36 flex-center rounded-full text-28 lg:j-text-14
        font-medium cursor-pointer hover:(bg-primary text-white) transition-all duration-300 
        px-[var(--jds-size-32)]
    }

    @media screen and (max-width: 1023px){
        .button-base{
            /* min-width: 52vw; */
        }
    }
    .amount-balance {
        @apply
        w-610 min-h-320 pt-60 pb-40 px-40 absolute left-70 -bottom-300 rounded-70 border border-solid border-white/50 overflow-hidden z-1
        shadow-[0px_0px_16px_rgba(0,0,0,0.05)]
        lg:(w-full j-min-h-140 j-left-0 j-bottom-0 j-rounded-16 j-pt-35 pb-0 px-0) !lg:rounded-b-0
        backdrop-blur-32 backdrop-saturate-100
        bg-white [&:not(backdrop-filter:blur())]:bg-white/50
    }
    .amount-text {
    @apply
        text-56 leading-56 font-semibold lg:(j-text-48 j-leading-48)
    }
    .amount-text-weak {
    @apply
        text-24 font-medium font-medium lg:(j-text-20 j-leading-20 j-mt-15)
    }
    .button-activity {
    @apply
        flex-center flex-auto min-w-250 max-h-80 px-36 py-25 bg-primary font-semibold
        rounded-full text-32 text-white cursor-pointer
        lg:(j-min-w-157 j-px-22 j-py-16 j-rounded-26 j-text-20 j-leading-20)
    }


</style>
